




<div *ngIf="callBackComponentShow" class="">
    <div id="kt_app_content_container" class="app-container container-xxl">
        <div class="card" *ngIf="surveyService.accessRoles.settings && surveyService.accessRoles.settings.callback_url && surveyService.accessRoles.settings.callback_url.view">
            <div class="card-header">
                <div class="card-title fs-3 fw-bold">Set Callback URL</div>
            </div>
            <div>
                <form [formGroup]="callback_form" (ngSubmit)="submit()" action="#">
                    <div class="card-body p-9">
                        <div class="row mb-8">
                            <div class="col-xl-3">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Complete URL</div>
                            </div>
                            <div class="col-xl-9 fv-row">
                                <input formControlName="complete" type="text" id="complete" [value]="complete_url" value="{{complete_url}}" class="complete form-control form-control-solid" >
                            </div>
                        </div>
                        <div class="row mb-8">
                            <div class="col-xl-3">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Over Quota URL</div>
                            </div>
                            <div class="col-xl-9 fv-row">
                                <input formControlName="over_quota" [value]="over_quota_url" type="text" id="over_quota" class="over_quota form-control form-control-solid" >
                            </div>
                        </div>
                        <div class="row mb-8">
                            <div class="col-xl-3">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Terminate URL</div>
                            </div>
                            <div class="col-xl-9 fv-row">
                                <input formControlName="terminate" [value]="terminate_url" type="text" id="terminate" class="terminate form-control form-control-solid" >
                            </div>
                        </div>
                        <div class="row mb-8">
                            <div class="col-xl-3">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Error URL</div>
                            </div>
                            <div class="col-xl-9 fv-row">
                                <input formControlName="failure" [value]="error_url" type="text" id="failure" class="failure form-control form-control-solid" >
                            </div>
                        </div>
                    </div>
                    <div class="card-footer d-flex justify-content-end py-6 px-9"
                    *ngIf="surveyService.accessRoles.settings && surveyService.accessRoles.settings.callback_url && surveyService.accessRoles.settings.callback_url.create">
                        <button type="submit" class="btn btn-primary" id="kt_project_settings_submit">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<div *ngIf="defaultAllLogin"class="">
    <div id="kt_app_content_container" class="app-container container-xxl">
        <div class="card" *ngIf="surveyService.accessRoles.settings && surveyService.accessRoles.settings.callback_url && surveyService.accessRoles.settings.callback_url.view">
            <div class="card-header">
                <div class="card-title fs-3 fw-bold">Set Callback URL</div>
            </div>
            <div *ngIf="defaultAllLogin" class="no-data text-muted fw-bold fs-5">
                Please select specific client to view this page
            </div> 
        </div>
    </div>
</div>




    